import { render, staticRenderFns } from "./LesiurtabsTheme2.vue?vue&type=template&id=c610075a"
import script from "./LesiurtabsTheme2.vue?vue&type=script&lang=js"
export * from "./LesiurtabsTheme2.vue?vue&type=script&lang=js"
import style0 from "./LesiurtabsTheme2.vue?vue&type=style&index=0&id=c610075a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports